let url = "";

if (process.env.REACT_APP_STAGE === "local") {
	url = "http://localhost:5200";
} else if (process.env.REACT_APP_STAGE === "dev") {
	url = "https://dev.api.teamtrack.com.br";
} else {
	url = "https://api.teamtrack.com.br";
}

export const Constants = {
	url,
	baseUrl: url.concat("/api/admin"),
	devTrack: {
		deadlineOptions: [
			{ value: 0, label: "Livre" },
			{ value: 30, label: "30 dias" },
			{ value: 60, label: "60 dias" },
			{ value: 90, label: "90 dias" },
		],
		contentTypeOptions: [
			{ value: "text", label: "Texto" },
			{ value: "video", label: "Vídeo" },
		],
	},
	customer: {
		personalSubPlanName: {
			MONTHLY: "Mensal",
			YEARLY: "Anual",
		},
	},
	stripeKey: process.env.REACT_APP_STRIPE_PK
};
